import React from 'react';
import { Card, Layout } from 'antd';
import { useTranslation } from 'react-i18next';

interface FeeRow {
  displayName: string;
  displayValue: string;
  operation: string;
}

export const ArFeesPage: React.FC = () => {
  const { t } = useTranslation();

  const fees: FeeRow[] = [
    {
      displayName: t('legal.arFees.fees.collectAndReceivePayments.displayName'),
      displayValue: t(
        'legal.arFees.fees.collectAndReceivePayments.displayValue'
      ),
      operation: 'collect_and_receive_payments',
    },
    {
      displayName: t('legal.arFees.fees.transferOrWithdrawFunds.displayName'),
      displayValue: t('legal.arFees.fees.transferOrWithdrawFunds.displayValue'),
      operation: 'transfer_or_withdraw_funds',
    },
  ];

  return (
    <Layout className="min-h-screen bg-[aliceblue] overflow-x-hidden">
      <Layout.Content className="bg-no-hidden-fees bg-no-repeat bg-cover mt-[200px] mb-[30px] px-4 md:px-8 lg:px-16">
        <div className="flex justify-center">
          <section className="w-full max-w-[900px] border border-[#D0E3ED] p-6 md:p-10 rounded-2xl">
            <div className="mb-8">
              <h2 className="text-3xl md:text-4xl font-bold text-gray-900 pb-4">
                {t('legal.arFees.title')}
              </h2>
              <p className="text-gray-700">{t('legal.arFees.description')}</p>
            </div>
            <Card className="rounded-xl bg-white shadow-sm border border-[#E6EEF3] overflow-hidden">
              <div className="overflow-x-auto">
                <table className="w-full min-w-[520px] border-collapse">
                  <thead>
                    <tr className="border-b border-[#E6EEF3]">
                      <th className="text-left text-sm font-semibold text-gray-700 px-4 py-3">
                        {t('legal.arFees.table.operation')}
                      </th>
                      <th className="text-left text-sm font-semibold text-gray-700 px-4 py-3">
                        {t('legal.arFees.table.fee')}
                      </th>
                    </tr>
                  </thead>
                  <tbody>
                    {fees.map((fee) => (
                      <tr
                        key={fee.operation}
                        className="border-b border-[#F0F4F7] last:border-b-0"
                      >
                        <td className="text-sm text-gray-800 px-4 py-4">
                          {fee.displayName}
                        </td>
                        <td className="text-sm font-semibold text-gray-900 px-4 py-4">
                          {fee.displayValue}
                        </td>
                      </tr>
                    ))}
                  </tbody>
                </table>
              </div>
            </Card>
          </section>
        </div>
      </Layout.Content>
    </Layout>
  );
};
